<template>
<div class="paper">
  <modal-form modal-id="import-inventory" animation="fadeInRight">
    <div slot="title">Import CSV Inventory</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg">
              <form @submit.prevent="importInventory">

                <p v-if="uploadErrorsCSV.length"><button @click="downloadCsvErrors">Download CSV Errors <strong>({{ uploadErrorsCSV.length }})</strong></button></p>
                <div v-else>
                  <label>Select CSV</label>
                  <input type="file" name="myFile" @change="onFileChange" />
                  <br />
                  <p v-if="uploadDisabled"><span>Uploading, please wait </span> <i class="fas fa-spinner fa-spin"></i></p>
                  <button class="btn-primary btn btn-xs" type="submit" v-else>Upload</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
  </modal-form>
  <modal-form modal-id="add-inventory" animation="fadeInRight">
      <div slot="title">Add New Inventory</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg">
              <div class="col-lg-4">Website</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addInventory['website']">
              </div>
              <div class="col-lg-4">TLD</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addInventory['tld']">
              </div>
              <div class="col-lg-4">Content</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addInventory['content']">
              </div>
              <div class="col-lg-4">Webmaster Name</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addInventory['webmaster']['name']">
              </div>
              <div class="col-lg-4">Webmaster Email</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addInventory['webmaster']['email']">
              </div>
              <div class="col-lg-4">Webmaster Cost</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addInventory['webmaster']['cost']">
              </div>
            </div>
            <div class="col-sm">
              <div class="col-lg-4">Ahrefs Rank</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addInventory['ahrefs']['rank']">
              </div>
              <div class="col-lg-4">Ahrefs DR</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addInventory['ahrefs']['dr']">
              </div>
              <div class="col-lg-4">Ahrefs rd</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addInventory['ahrefs']['rd']">
              </div>
              <div class="col-lg-4">Ahrefs Keywords</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addInventory['ahrefs']['keywords']">
              </div>
              <div class="col-lg-4">Ahrefs Traffic</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addInventory['ahrefs']['traffic']">
              </div>
              <div class="col-lg-4">Client Price</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addInventory['clientPrice']">
              </div>
              <div class="col-lg-4">Link Type</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addInventory['linkType']">
              </div>
              <div class="col-lg-4">Duration</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addInventory['duration']">
              </div>
              <div class="col-lg-4">Rule Casino</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addInventory['ruleCasino']">
              </div>
              <div class="col-lg-4">Category</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addInventory['category']">
              </div>
              <div class="col-lg-4">Langages</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addInventory['languages']">
              </div>
              <div class="col-lg-4">Active</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addInventory['active']">
              </div>
              <div class="col-lg-4">1 Year Homepage Price</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addInventory['yearHomepagePrice']">
              </div>
              <div class="col-lg-4">Homepage Rental Client Price</div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="addInventory['homepageRentalClientPrice']">
              </div>
            </div>
          </div>
          <div class="row m-t-md">
            <div class="col-lg-12">
              <button class="btn btn-sm btn-primary" @click="saveInventory">Save</button>
            </div>
          </div>
        </div>
      </div>
    </modal-form>
    <div class="ibox-title">
    <h5>Inventory</h5>
      <div class="pull-right">
        <button class="btn btn-xs btn-primary mx-2" data-toggle="modal" data-target="#import-inventory" @click="uploadErrorsCSV=[]">Import Inventory CSV</button>
        <button class="btn btn-xs btn-primary mx-2" @click="toInventoryCreate">Add Inventory</button>
        <button class="btn btn-xs btn-primary mx-2" @click="exportInventory">Export CSV</button>
      </div>
    </div>
    <hr />
    <div>
      <div class="col-lg-12 col-md-12">
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <input placeholder="Website" type="text" v-model="filters['website']" name="" class="col-lg-8 form-control">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <input placeholder="Webmaster" type="text" v-model="filters['webmaster.name']" name="" class="col-lg-8 form-control">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <input placeholder="Webmaster Email" type="text" v-model="filters['webmaster.email']" name="" class="col-lg-8 form-control">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <v-select placeholder="Tld" :options="tlds" multiple label="label" v-model="filters.tld">
            </v-select>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-md-12">
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <v-select placeholder="Categories" :options="categories" multiple label="label" v-model="filters.category">
            </v-select>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
          <v-select
            placeholder="Languages"
            multiple
            :options="languages"
            label="label"
            v-model="filters['languages']"
          >
          </v-select>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
          <v-select
            placeholder="Rule Casino"
            :options="ruleCasino"
            label="label"
            v-model="filters['ruleCasino']"
          >
          </v-select>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
          <v-select
            placeholder="Active"
            :options="active"
            label="label"
            v-model="filters['active']"
          >
          </v-select>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 m-t-sm">
          <h4>Ahrefs:</h4>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div class="display-flex">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input side-input-text">Rank:</div>
            <input type="number" v-model="filters['ahrefs.rank']['$gte']" min="0" name="" id="iPostsFrom" placeholder="from"
                   class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input">
            <input type="number" v-model="filters['ahrefs.rank']['$lte']" min="0" name="" id="iPostsTo" placeholder="to"
                   class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input pull-right" ref="postsTo">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div class="display-flex">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input side-input-text">Rd:</div>
            <input type="number" v-model="filters['ahrefs.rd']['$gte']" min="0" name="" id="iPostsFrom" placeholder="from"
                   class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" ref="postsFrom">
            <input type="number" v-model="filters['ahrefs.rd']['$lte']" min="0" name="" id="iPostsTo" placeholder="to"
                   class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input pull-right" ref="postsTo">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div class="display-flex">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input side-input-text">Dr:</div>
            <input type="number" v-model="filters['ahrefs.dr']['$gte']" min="0" name="" id="iPostsFrom" placeholder="from"
                   class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" ref="postsFrom">
            <input type="number" v-model="filters['ahrefs.dr']['$lte']" min="0" name="" id="iPostsTo" placeholder="to"
                   class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input pull-right" ref="postsTo">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div class="display-flex">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input side-input-text">Keywords:</div>
            <input type="number" v-model="filters['ahrefs.keywords']['$gte']" min="0" name="" id="iPostsFrom" placeholder="from"
                   class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" ref="postsFrom">
            <input type="number" v-model="filters['ahrefs.keywords']['$lte']" min="0" name="" id="iPostsTo" placeholder="to"
                   class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input pull-right" ref="postsTo">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div class="display-flex">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input side-input-text">Traffic:</div>
            <input type="number" v-model="filters['ahrefs.traffic']['$gte']" min="0" name="" id="iPostsFrom" placeholder="from"
                   class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" ref="postsFrom">
            <input type="number" v-model="filters['ahrefs.traffic']['$lte']" min="0" name="" id="iPostsTo" placeholder="to"
                   class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input pull-right" ref="postsTo">
          </div>
        </div>
        <div class="col-lg-12 col-md-12 m-t-sm">
          <h4>Price (w=webmaster, c=client):</h4>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div class="display-flex">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input side-input-text">w-cost:</div>
            <input type="number" v-model="filters['webmaster.cost']['$gte']" min="0" placeholder="from"
                   class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input">
            <input type="number" v-model="filters['webmaster.cost']['$lte']" min="0" placeholder="to"
                   class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input pull-right">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div class="display-flex">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input side-input-text">c-price:</div>
            <input type="number" v-model="filters['clientPrice']['$gte']" min="0" placeholder="from"
                   class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input">
            <input type="number" v-model="filters['clientPrice']['$lte']" min="0" placeholder="to"
                   class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input pull-right">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div class="display-flex">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input side-input-text">Created:</div>
            <input type="date" v-model="filters['createdAt']['$gte']" placeholder="from"
                   class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input">
            <input type="date" v-model="filters['createdAt']['$lte']" placeholder="to"
                   class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input pull-right">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div class="display-flex">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input side-input-text">Updated:</div>
            <input type="date" v-model="filters['updatedAt']['$gte']" placeholder="from"
                   class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input">
            <input type="date" v-model="filters['updatedAt']['$lte']" placeholder="to"
                   class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input pull-right">
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-md-12">
        <div class="col-lg-12 m-t-sm text-right">
          <button class="btn btn-sm btn-primary" @click="resetFilter">Reset</button>
          <button class="btn btn-sm btn-primary" @click="getInventory">Search</button>
        </div>
      </div>
    </div>
    <div class="row m-t-md"></div>
    <hr />
    <div style="padding:0 20px">
      <div style="float: right;">
        <label>&nbsp;</label><br />
        <select @change="columnSort">
          <option value="1" selected>asc</option>
          <option value="-1">desc</option>
        </select>
      </div>
      <div style="width:200px;float: right; margin:0 10px">
        <label>Sort by:</label>
        <select @change="columnSort" style="width:100%; cursor:pointer">
          <option value="0" style="text-align:center"> -- Select Column --</option>
          <option value="website">Website</option>
          <option value="webmaster.name">Webmaster</option>
          <option value="webmaster.email">Webmaster Email</option>
          <option value="webmaster.cost">Webmaster Price</option>
          <option value="clientPrice">Client Price</option>
          <option value="tld">Tld</option>
          <option value="languages">Language</option>
          <option value="ahrefs.dr">Ahref Dr</option>
          <option value="ahrefs.rd">Ahref Rd</option>
          <option value="ahrefs.rank">Ahref Rank</option>
          <option value="ahrefs.keywords">Ahref Keywords</option>
          <option value="ahrefs.traffic">Ahref Traffic</option>
        </select>
      </div>
    </div>
    <br />
    <br />
    <div  style="padding:20px">
    <table class="table table-dark">
    <thead>
    <tr>
        <th>Website</th>
        <th>Tld</th>
        <th>Webmaster</th>
        <th>Email</th>
        <th>Email 2</th>
        <th>
          Webmaster/Client Price<br />
          Year Homepage/Rental Client Price
        </th>
        <th>Language</th>
        <th>Categories</th>
        <th>AHref</th>
        <th>Created On</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="inv in inventory" :key="inv._id">
        <td>
        <router-link :to="'/instalinko/inventory/' + inv.id">{{ inv.website }}</router-link>
        </td>
        <td>{{ inv.tld }}</td>
        <td>{{ inv.webmaster.name }}</td>
        <td>{{ inv.webmaster.email }}</td>
        <td>{{ inv.webmaster.email2 }}</td>
        <td>{{ (inv.webmaster.cost||0).toFixed(2) }} / {{ inv.clientPrice }}<br />
          {{ inv.yearHomepagePrice }} / {{ inv.homepageRentalClientPrice }}
        </td>
        <td>{{ inv.languages.toString() }}</td>
        <td>{{ inv.category.toString() }}</td>
        <td>
          Rank: {{ inv.ahrefs.rank }}<br />
          Rd: {{ inv.ahrefs.rd }}<br />
          Dr: {{ inv.ahrefs.dr }}<br />
          Keywords: {{ inv.ahrefs.keywords }}<br />
          Traffic: {{ inv.ahrefs.traffic }}
        </td>
        <td>{{ inv.createdAt | aTime }}</td>
    </tr>
    </tbody>
    </table>
  </div>
    <hr />
    <div class="pagination">
      <div>
        <span><strong>Records: </strong>{{ totalPages }}</span>
      </div>
      <div>
        <button @click="prevPage" :disabled="page === 1">Previous</button>
        <span>&nbsp;{{ page }} / {{ Math.ceil(totalPages/perPage) }}&nbsp;</span>
        <button @click="nextPage" :disabled="page >= totalPages/perPage">Next</button>
      </div>
      <div>
        <strong for="pageSize">Rows:&nbsp;</strong>
        <select id="pageSize" v-model="perPage" @change="changePageSize">
          <option v-for="size in pageSizes" :value="size" :key="size">{{ size }}</option>
        </select>
      </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import Modal from '@/components/Helpers/Modal/Form'
import Papa from 'papaparse'

const isObject = (item) => {
  return typeof item === 'object' && item !== null && !Array.isArray(item)
}

const isArray = (item) => {
  return Array.isArray(item)
}

const formFilter = (obj, format) => {
  let filter = {}
  Object.keys(obj).forEach(item => {
    if (isObject(obj[item])) {
      Object.keys(obj[item]).forEach(el => {
        if (!obj[item][el]) delete obj[item][el]
      })
      Object.keys(obj[item]).length && (filter[item] = obj[item])
    } else if (isArray(obj[item])) {
      if (obj[item].length) filter[item] = {$in: obj[item]}
    } else {
      if (obj[item]) filter[item] = format[item] ? format[item](obj[item]) : obj[item]
    }
  })
  if (filter.ruleCasino) {
    filter.ruleCasino = filter.ruleCasino === 'Yes' || false
  }
  if (filter.active) {
    filter.active = filter.active === 'Yes' || false
  }
  return filter
}

const field = {
  strContains: (val) => ({$regex: `.*${val}.*`, $options: 'i'})
}

// Add Inventory Defaults
const inventoryAddDefaults = {
  website: '',
  tld: '',
  content: '',
  webmaster: {
    name: '',
    email: '',
    cost: 0
  },
  ahrefs: {
    rank: 0,
    dr: 0,
    rd: 0,
    keywords: 0,
    traffic: 0
  },
  clientPrice: 0,
  linkType: '',
  duration: '',
  ruleCasino: '',
  category: '',
  languages: '',
  active: true,
  yearHomepagePrice: 0,
  homepageRentalClientPrice: 0
}

const defaultFilters = {
  'ahrefs.rank': {},
  'ahrefs.rd': {},
  'ahrefs.dr': {},
  'ahrefs.keywords': {},
  'ahrefs.traffic': {},
  'webmaster.cost': {},
  'clientPrice': {},
  'createdAt': {},
  'updatedAt': {}
}

export default {
  data () {
    return {
      uploadErrorsCSV: [],
      uploadApi: process.env.API === 'https://api.aphexmedia.com' ? 'https://api.instalinko.com' : '/v2',
      sort: {field: '0', direction: '1'},
      active: ['Yes', 'No'],
      ruleCasino: ['Yes', 'No'],
      tlds: [],
      languages: [],
      categories: [],
      // languages: [
      //   {label: 'Unknown', id: 'unknown'},
      //   {label: 'Not built', id: 'not-built'},
      //   {label: 'Building', id: 'building'},
      //   {label: 'Built', id: 'built'},
      //   {label: 'Waiting Deploy', id: 'waiting-deploy'},
      //   {label: 'Waiting Deploy Client', id: 'waiting-deploy-client'},
      //   {label: 'Disabled', id: 'disabled'}
      // ],
      filters: {
        'ahrefs.rank': {},
        'ahrefs.rd': {},
        'ahrefs.dr': {},
        'ahrefs.keywords': {},
        'ahrefs.traffic': {},
        'webmaster.cost': {},
        'clientPrice': {},
        'createdAt': {},
        'updatedAt': {}
      },
      format: {
        'webmaster.name': field.strContains,
        'webmaster.email': field.strContains,
        'website': field.strContains
      },
      uploadDisabled: false,
      file: null,
      inventory: [],
      addInventory: {...inventoryAddDefaults},
      page: 1,
      perPage: 10,
      totalPages: 0,
      pageSizes: [10, 25, 50]
    }
  },
  async mounted () {
    const [tld, categories, languages] = await Promise.all([
      axios.get(`/v2/instalinko/inventory/tlds`),
      axios.get(`/v2/instalinko/inventory/categories`),
      axios.get(`/v2/instalinko/inventory/languages`)
    ])
    this.tlds = tld.data
    this.categories = categories.data
    this.languages = languages.data
    this.getInventory()
  },
  components: {
    modalForm: Modal
  },
  methods: {
    toInventoryCreate () {
      this.$router.push({ name: 'AddInventory' })
    },
    resetFilter () {
      this.filters = JSON.parse(JSON.stringify(defaultFilters))
      this.getInventory()
    },
    columnSort (e) {
      if (Math.abs(e.target.value) === 1) {
        this.sort.direction = e.target.value
      } else {
        this.sort.field = e.target.value
      }
      this.getInventory()
    },
    onFileChange (event) {
      this.file = event.target.files[0]
    },
    async exportInventory () {
      const {data} = await axios.get(`/v2/instalinko/inventory/download`, { params: {filter: formFilter(this.filters, this.format)}, responseType: 'blob' })
      const url = URL.createObjectURL(new Blob([data]))
      const a = document.createElement('a')
      a.href = url
      a.download = 'inventory-export.csv'
      a.click()
      URL.revokeObjectURL(url)
    },
    downloadCsvErrors (e) {
      e.preventDefault()
      const csvData = Papa.unparse(this.uploadErrorsCSV)

      // Create a Blob containing the CSV data
      const blob = new Blob([csvData], { type: 'text/csv' })

      // Create a URL for the Blob
      const blobURL = window.URL.createObjectURL(blob)

      // Create a link element for downloading
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = blobURL
      a.download = 'data.csv' // Set the file name here

      // Append the link to the document
      document.body.appendChild(a)

      // Trigger a click event on the link
      a.click()

      // Remove the link element after the download
      document.body.removeChild(a)

      // Revoke the Blob URL to free up resources
      window.URL.revokeObjectURL(blobURL)
    },
    async importInventory () {
      this.uploadDisabled = true
      console.log('import inventory')
      console.log(this.file)
      const formData = new FormData()
      formData.append('myFile', this.file)

      try {
        this.uploadErrorsCSV = []
        const uploadErrors = await axios.post(this.uploadApi + '/instalinko/inventory/upload', formData)
        this.uploadErrorsCSV = uploadErrors.data
        this.$toastr.success('Inventory imported successfully', 'Brilliant stuff lad')
      } catch (err) {
        this.$toastr.error(err, 'Unable to import file')
      }
      this.file = null
      this.uploadDisabled = false
    },
    async saveInventory () {
      const addInventory = {...this.addInventory}
      try {
        console.log(addInventory)
        const res = await axios.post('/v2/instalinko/inventory', addInventory)
        console.log(res)
        this.inventory = [...this.inventory, addInventory]
        this.$toastr.success('Inventory added successfully', 'Brilliant stuff lad')
      } catch (err) {
        this.$toastr.error(err, 'Unable to create inventory')
      }
    },
    changePageSize () {
      this.page = 1 // reset the page to the first page when changing the page size
      this.getInventory()
    },
    async getInventory () {
      try {
        const res = await axios.get(`/v2/instalinko/inventory`, {
          params: {
            filter: formFilter(this.filters, this.format),
            options: {
              page: this.page,
              perPage: this.perPage,
              sort: this.sort.field !== '0' ? {
                [this.sort.field]: Number(this.sort.direction)
              } : {}
            }
          }
        })
        this.inventory = res.data
        this.totalPages = Number(res.headers['x-total-records'])
      } catch (err) {
        console.log(err)
        this.$toastr.error(err, 'Unable to get inventory')
      }
    },
    nextPage () {
      if (this.page < this.totalPages) {
        this.page++
        this.getInventory()
      }
    },
    prevPage () {
      if (this.page > 1) {
        this.page--
        this.getInventory()
      }
    }
  }
}
</script>
<style>
.paper{
background: #fff;
margin-top: 10px;
}
.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pagination>div {
  flex: 1;
  padding: 10px;
  display: flex; /* Enable vertical alignment */
  align-items: center;
}

.pagination>div:nth-child(2) {
  justify-content: center;
}

.pagination>div:nth-child(3) {
  justify-content: flex-end;
}

</style>



// WEBPACK FOOTER //
// src/components/Pages/Instalinko/Inventories.vue